export default __webpack_public_path__ + "static/media/Banner3.6e3ab91c.png";